import axios from '../../helpers/axios-setup';
import { LabRequest } from '../../components/pages/atl-testing/types';

export const saveLR = (id: number, data: LabRequest) => axios.patch(`/lab-requests/save/${id}`, data);
